export default "__VITE_ASSET__LNlGgcuK__"